import React from 'react'

const NotFoundTemplate: React.FunctionComponent<{}> = (props) => (
  <h1>Not found</h1>
)

export default NotFoundTemplate
